import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { PartTypeRow } from 'model/Project/BoMItemRow'
import { BomItemUpdateRequestDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ShowException } from 'store/Application/appActions'
import { RootAppState } from 'store/configureStore'
import { projectAPIBuilder } from './BoMAsyncActions'
import { fetchProject } from './fetchProject'

export const batchUpdateBomItems = createAsyncThunk<
  void,
  BomItemUpdateRequestDto[],
  {
    state: RootAppState
  }
>(
  'project/batch-update-bom-items',
  async (payload: BomItemUpdateRequestDto[], thunkAPI) => {
    const { projectId, api } = projectAPIBuilder(thunkAPI.getState)

    try {
      const state = thunkAPI.getState()
      const filteredPayload = payload.filter((item) => {
        const currentBomItem = state.project.flatView[
          item.bomItemId
        ] as PartTypeRow

        return (
          !_.isEqual(currentBomItem.materialSummary.tokens, item.keywords) ||
          currentBomItem.financial?.quantity !== item.quantity ||
          currentBomItem.comment != item.comment
        )
      })

      await api.BatchUpdateBomItems(projectId, filteredPayload)
      await thunkAPI.dispatch(fetchProject({ projectId: projectId }))
    } catch (err) {
      ShowException('project', err)
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw err
    }
  }
)
